import { useContext } from 'react';
import { useParams } from 'react-router';
import { Button } from 'reactstrap';
import { MapContext } from '../../../contexts/MapContext';
import { copyFeatureWithoutProperties } from '../../../utils/layers';
import { mapModes } from '../../../constants/map';
import HeadlandsIcon from '../../icons/HeadlandsIcon';

const CreateHeadlandButton = ({
  feature,
  isInnerFeature = false, // Flip the headland outside of the feature
  name = feature.properties.name,
  onCreate,
  className,
  ...buttonProps
}) => {
  const { farmId } = useParams();
  const {
    layers: { addLayerFeature },
    mapState: { setMapMode },
  } = useContext(MapContext);
  return (
    <Button
      onClick={() => {
        if (onCreate) onCreate();

        const newFeature = copyFeatureWithoutProperties(feature);
        newFeature.properties = {
          name,
          isInnerFeature,
        };

        const [{ id }] = addLayerFeature('HEADLANDS', farmId, newFeature);
        setMapMode(mapModes.LAYER_FEATURE_ENGAGED, id);
      }}
      className={`d-flex align-items-center ${className}`}
      {...buttonProps}
    >
      <HeadlandsIcon className="d-flex mr-2 align-items-center" />
      Create Headland
    </Button>
  );
};

export default CreateHeadlandButton;
